import styled from '@emotion/styled';
import { bodyB } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const MobileDivider = styled.div`
  margin-top: 32px;
  position: relative;
  left: -16px;
  width: calc(100% + 32px);
  height: 10px;
  background-color: #222425;
  ${DESKTOP} {
    display: none;
  }
`;

export const Container = styled.div`
  position: sticky;
  top: 49px;
  border-bottom: 1px solid ${vars.neutral[80]};
  background-color: rgba(20, 22, 23, 0.8);
  backdrop-filter: blur(4px);
  z-index: 1;
  transform: translateX(-16px);
  width: calc(100% + 32px);
  padding: 0 16px;
  ${DESKTOP} {
    margin-top: 60px;
    padding: 0;
    transform: translateX(0);
    width: 100%;
    top: 60px;
  }
`;

export const SectionTitles = styled.div`
  display: flex;
  gap: 12px;
  ${DESKTOP} {
    gap: 60px;
  }
`;
export const SectionTitle = styled.div<{ selected: boolean }>`
  height: 48px;
  padding: 14px 4px;
  ${bodyB};
  color: ${({ selected }) =>
    selected ? vars.brand.default : vars.neutral[60]} !important;
  border-bottom: ${({ selected }) =>
    selected ? `2px solid ${vars.brand.default}` : 'none'};
  cursor: pointer;
  ${DESKTOP} {
    padding: 14px 0;
    ${bodyB};
  }

  transition:
    color 0.2s linear,
    border-bottom-color 0.2s linear,
    border-bottom-width 0.2s linear;
`;
